import {
    useMemo,
} from 'react'
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined'

import {
    TooltipWrapper,
} from '../Tooltip'

import useStyles from './NotificationIcon.styles'
import {
    NotificationIconProps,
} from './notificationIcon.types'

type Props = NotificationIconProps & {
    children: JSX.Element | string,
    isInlineIcon?: boolean,
}

/* eslint-disable react/default-props-match-prop-types */
const defaultProps: Partial<Props> = {
    content: '',
    isInlineIcon: false,
}

const NotificationIcon = ({
    children,
    content,
    type,
    tooltipPlacement,
    isInlineIcon,
}: Readonly<Props>) => {
    const {
        classes,
        cx,
    } = useStyles({
        isInlineIcon,
    })

    const {
        tooltipValue, ownTooltipProps,
    } = useMemo(() => {
        const isJSXFnElement = typeof content === 'function'
        const shouldAppyContentStyles = typeof content !== 'string'
        const Content = isJSXFnElement ? content : undefined

        return {
            tooltipValue: isJSXFnElement ? <Content /> : content,
            ownTooltipProps: {
                enterDelay: shouldAppyContentStyles ? 500 : 100,
                placement: tooltipPlacement ?? (shouldAppyContentStyles ? 'bottom-start' : 'bottom'),
            },
        }
    }, [
        content,
        tooltipPlacement,
    ])

    if (!type) return <span>{children}</span>

    return (
        <div className={classes.container}>
            {children}
            <TooltipWrapper
                value={tooltipValue}
                ownTooltipProps={ownTooltipProps}
            >
                <div className={classes.iconContainer}>
                    <ErrorOutlinedIcon
                        className={cx(classes[type], classes.icon)}
                    />
                </div>
            </TooltipWrapper>
        </div>
    )
}

NotificationIcon.defaultProps = defaultProps

export default NotificationIcon
